import axios from "../../js/project-axios.js"

const getStartTime = () => {
    return axios.get("/capital/report/getStartTime");
};

const list = (time, level, accountId, accountSubjectTypes) => {
    return axios.get("/capital/report/list", {
        params: {
            time,
            level,
            accountId,
            accountSubjectType: accountSubjectTypes
        }
    });
};

export default {
    getStartTime,
    list
};